/// <amd-module name="Build/Flux/Actions/ContributionData" />
import { Action } from "Build/Flux/Action";
import { ContributionSource } from "Build/Flux/Sources/Contribution";

import { IVssPageContext } from "VSS/Platform/Context";

export type DataParser<T> = (providerData: any) => T;
export type ErrorHandler = (error: Error) => void;


export interface IContributionDataActionCreatorOptions<T> {
    pageContext: IVssPageContext;
    actionHub: ContributionDataActionHub<T>;
    dataParser: DataParser<T>;
    errorHandler?: ErrorHandler;
}

export class ContributionDataActionCreator<T> {
    private _actionHub: ContributionDataActionHub<T>;
    private _dataParser: DataParser<T>;
    private _source: ContributionSource;
    private _errorHandler: ErrorHandler;

    constructor(options: IContributionDataActionCreatorOptions<T>) {
        this._actionHub = options.actionHub || new ContributionDataActionHub<T>();
        this._dataParser = options.dataParser;
        this._source = new ContributionSource({
            pageContext: options.pageContext
        });
        this._errorHandler = options.errorHandler || this._defaultErrorHandler;
    }

    public fetchContributionData(contributionId: string, routeValues?: { [key: string]: string }, refresh: boolean = false, dataAvailableCallback?: (data: T, routeValues?: { [key: string]: string }) => void): void {
        this._source.getDataAsync(contributionId, routeValues, refresh).then(data => {
            if (!!data) {
                const payload = this._dataParser(data);
                this._actionHub.contributionDataAvailable.invoke(payload);
                if(dataAvailableCallback) {
                    dataAvailableCallback(payload, routeValues);
                }
            }
        }).catch(this._errorHandler);
    }

    private _defaultErrorHandler = (error: Error) => {
        // TODO: do something default here
        console.error(error);
    }
}

export class ContributionDataActionHub<T> {
    private _contributionDataAvailable: Action<T>;

    constructor() {
        this._contributionDataAvailable = new Action<T>();
    }

    public get contributionDataAvailable(): Action<T> {
        return this._contributionDataAvailable;
    }
}
